// @flow

import React from "react";
import "./PayPalButton.scss";
import {PayPalApproveResponse, PayPalCancelResponse} from "../../../api/PayPalApi";
import {PAYMENT_METHODS} from "../../../models/PaymentRequests";
import {useTranslation} from "react-i18next";
import usePayPalScript from "../../../hooks/usePayPalScript";
import Spinner from "react-spinkit";

export type PayPalButtonProps = {
    buyerName: string,
    buyerEmail: string,
    payPalPaymentRef: string,
    onPaymentSuccess: (referenceId: string) => void,
    onPaymentCancelled: (referenceId: string) => void,
    onPaymentError: () => void,
    // asked on the click: whether all is there to pay (the consent); no, and PayPal opens nothing
    canPay?: () => boolean,
}

const P24PayPalButton = (props: PayPalButtonProps) => {

    const {t} = useTranslation();
    const {
        PayPalButton,
        PayPalFields,
        scriptResolved,
        hasError,
        getFundingSource
    } = usePayPalScript("capture");

    const onApprove = (response: PayPalApproveResponse) => {
        props.onPaymentSuccess(response.paymentID);
    };

    const onClick = (_data, actions) => {
        return (props.canPay && !props.canPay()) ? actions.reject() : actions.resolve();
    };

    const onCancel = (data: PayPalCancelResponse) => {
        console.error(t("cart.paymentMethods.paymentWindowClosed"));
        alert(t("cart.paymentMethods.paymentWindowClosed"));
        props.onPaymentCancelled(data.orderID);
    };

    const onError = (err) => {
        console.error("paypal p24 error: ", err);
        props.onPaymentError();
    };

    if(hasError) {
        console.error("PayPalButton, scriptResolved but has error, cannot render Button");
    }

    return (
        <>
        {(scriptResolved && !hasError) ? <>
                    <div className={"p24-paymentFields"}>
                        <PayPalFields
                            fundingSource={getFundingSource(PAYMENT_METHODS.PRZELEWY24)}
                            fields={{
                                name: {
                                    value: props.buyerName,
                                    disabled: true
                                },
                                email: {value: props.buyerEmail},
                            }}
                            onClose={() => {}}
                        />
                    </div>
                    <PayPalButton
                        fundingSource={getFundingSource(PAYMENT_METHODS.PRZELEWY24)}
                        onClick={onClick}
                        createOrder={() => {
                            return props.payPalPaymentRef;
                        }}
                        onApprove={onApprove}
                        onCancel={onCancel}
                        onError={onError}
                        style={{
                            layout: "horizontal",
                            label: "pay",
                            shape: "pill"
                        }}
                    />
                </>
                : <div style={{
                    display: "flex",
                    justifyContent: "center"
                }}>
                    {!hasError &&
                        <Spinner name="ball-beat" className="hpm-spinnerButton"/>
                    }
                </div>
        }
        </>
    );
};

export default P24PayPalButton;
